// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* eslint-disable design-system/ensure-design-token-usage */
/* stylelint-disable design-system/ensure-design-token-usage */
/* we are purposely not using design tokens, since we do not want the modal to change
for light vs. dark mode */
.iZrfJt4L_7aaRD {
  display: flex;
  position: relative;
  flex-direction: column;
  width: 90dvw;
  min-width: 720px;
  max-width: 1920px;
  height: 90dvh;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 16px;
  background-color: #0c66e4;
  text-align: center;
}
.dqyOwqvJckHvwI > div {
  margin: 0;
}
.dqyOwqvJckHvwI {
  scrollbar-gutter: initial;
}
.MgDwsCZa5_UTrU {
  display: flex;
  position: relative;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  height: 48px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  background-color: #1d7afc;
  gap: 16px;
}
.WVlGBDndTi9bEy {
  width: 12%;
  max-width: 140px;
  padding: 12px 0;
  cursor: pointer;
}
.HvB179pUa2Ouga {
  border-radius: 3px;
  background-color: #85b8ff;
}
.uWySOp0uvvMcws {
  width: 0;
  height: 6px;
  border-radius: 3px;
  background-color: #e9f2ff;
}
@keyframes WYGtmFDLC9_R31 {
  to {
    width: 100%;
  }
}
.xtN2KGTg2NRgh_ .uWySOp0uvvMcws {
  animation-name: WYGtmFDLC9_R31;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
}
.DgHDBHVV6WyBx_ .uWySOp0uvvMcws {
  width: 100%;
}
.cnPaT2fwiE5kTT {
  animation-duration: 6s;
}
.M0jfeBHFaczJHf {
  animation-duration: 6s;
}
.LveGPmAAb2HOsY {
  animation-duration: 5s;
}
.fUP2wahVPindW7 {
  animation-duration: 8s;
}
.z4xXHgDFUraJpD {
  position: absolute;
  top: 8px;
  right: 16px;
  color: #ffffff;
}
.z4xXHgDFUraJpD:hover,
.z4xXHgDFUraJpD:active {
  color: #ffffff;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `iZrfJt4L_7aaRD`,
	"overlayOverrides": `dqyOwqvJckHvwI`,
	"modalNavigation": `MgDwsCZa5_UTrU`,
	"progressIndicator": `WVlGBDndTi9bEy`,
	"progressIndicatorBackground": `HvB179pUa2Ouga`,
	"progressIndicatorInner": `uWySOp0uvvMcws`,
	"activeProgressIndicator": `xtN2KGTg2NRgh_`,
	"progressIndicatorFill": `WYGtmFDLC9_R31`,
	"filledProgressIndicator": `DgHDBHVV6WyBx_`,
	"firstProgressIndicator": `cnPaT2fwiE5kTT`,
	"secondProgressIndicator": `M0jfeBHFaczJHf`,
	"thirdProgressIndicator": `LveGPmAAb2HOsY`,
	"fourthProgressIndicator": `fUP2wahVPindW7`,
	"closeButton": `z4xXHgDFUraJpD`
};
export default ___CSS_LOADER_EXPORT___;
